import * as React from 'react';
var TOOLTIP_MARKER_CLASS = 'k-chart-shared-tooltip-marker';
/**
 * @hidden
 */

var SharedTooltipContent = function SharedTooltipContent(props) {
  var categoryText = props.categoryText,
      colorMarker = props.colorMarker,
      colspan = props.colspan,
      nameColumn = props.nameColumn,
      points = props.points;

  var pointsMap = function pointsMap(point, idx) {
    return React.createElement("tr", {
      key: idx
    }, colorMarker && React.createElement("td", null, React.createElement("span", {
      className: TOOLTIP_MARKER_CLASS,
      style: {
        backgroundColor: point.series.color
      }
    })), nameColumn && React.createElement("td", null, point.series.name), React.createElement("td", {
      dangerouslySetInnerHTML: {
        __html: point.formattedValue
      }
    }));
  };

  return React.createElement("table", null, React.createElement("thead", null, React.createElement("tr", null, React.createElement("th", {
    colSpan: colspan
  }, categoryText))), React.createElement("tbody", null, points.map(pointsMap)));
};

export { SharedTooltipContent };